// @vue/component
export default {
  name: 'AccountList',
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSelectAccount(account) {
      this.$emit('account-selected', account);
    },
    getBackgroundImage(account) {
      return account.installation.logo ? `url('${account.installation.logo}')` : '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/widgets/AccountList/AccountList.js